import React from 'react';
import styled from 'styled-components';
import { SectionParent, H1, H2, B1, B3 } from '../../StyledComponents';
import odroid from '../../../assets/v2/DigitalSignage/odroidt.png';
import khadas from '../../../assets/v2/DigitalSignage/khadas.png';
import odroidc2 from '../../../assets/v2/DigitalSignage/odroidc2.png';
import odroidlogo from '../../../assets/v2/DigitalSignage/odroidlogo.png';
import khadaslogo from '../../../assets/v2/DigitalSignage/khadaslogo.png';
import EnhancedBadge from '../../../assets/v2/DigitalSignage/banner.svg';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import { navigate } from '@reach/router';

const Section = styled(SectionParent)`
  padding: 0rem 14rem;
  @media (max-width: 1750px) and (min-width: 1440px) {
    padding: 0rem 4rem;
  }
  @media (max-width: 1440px) and (min-width: 768px) {
    padding: 0rem 2rem;
  }
  @media (max-width: 768px) {
    padding-top: 9px;
    padding-left: 2rem;
    padding-right: 2rem;
  }
  @media (max-width: 520px) {
    padding: 1rem 3rem;
  }
  @media (max-width: 400px) {
    padding: 1rem;
  }
`;
const SectionContainer = styled.div`
  padding-left: 2rem;
  padding-right: 2rem;
  grid-template-columns: repeat(3, 1fr);
  @media (max-width: 1200px) {
    grid-template-columns: repeat(2, 1fr);
  }
  @media (max-width: 768px) {
    grid-template-columns: repeat(1, 1fr);
    padding-left: 5rem;
    padding-right: 5rem;
    grid-gap: 1rem;
  }
  @media (max-width: 520px) {
    padding-left: 0rem;
    padding-right: 0rem;
  }
  display: grid;
  grid-gap: 1rem;
  padding-top: 5rem;
  padding-bottom: 2rem;
`;

const Card = styled.a`
  border-radius: 4px;
  cursor: pointer;
  /* box-shadow: 0 2px 13px 0 rgba(51, 41, 85, 0.2); */
  background-color: #ffffff;
  min-height: 20rem;
  display: grid;
  margin-bottom: 1rem;
  grid-template-columns: repeat(3, 1fr);
  /* @media (max-width: 1100px) {
    grid-column: span 2;
  } */
  @media (max-width: 520px) {
    padding: 1rem;
    /* grid-template-columns: repeat(1, 1fr); */
  }
`;

const CardContent = styled.div`
  padding: 1rem;
  padding-left: 3.5rem;
  grid-column: span 2;
  width: 100%;
  background: #a1c934;
  align-self: start;
  height: 100%;
  display: grid;
  @media (max-width: 1750px) and (min-width: 1500px) {
    width: 90%;
  }
  @media (max-width: 768px) {
    padding: 1rem;
    padding-top: 3rem;
    margin-top: -2rem;
    height: fit-content;
    width: 100%;
    display: grid;
    grid-column: span 3;
    justify-items: center;
  }
`;

const CardDescription = styled(B3)`
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  font-size: 16px !important;
  letter-spacing: normal;
  text-align: left;
  color: #ffffff;
  @media (max-width: 768px) {
    font-size: 14px !important;
  }
  @media (max-width: 520px) {
    text-align: center;
  }
`;

const GridItem = styled.div`
  grid-column: span 1;
  min-width: 14rem;
  justify-self: end;
  margin-top: -2rem;
  width: fit-content;
  height: fit-content;
  margin-right: -2.5rem;
  position: relative;
  background: white;
  box-shadow: 0 2px 8px 0 rgba(16, 25, 38, 0.88);
  border-radius: 4px;
  /* margin-left: 12%; */
  position: relative;
  @media (max-width: 768px) {
    flex: 0 0 calc(100%);
    /* display: grid; */
    justify-items: center;
    justify-self: center;
    grid-column: span 3;
    margin-right: 0;
    width: 80%;
    margin-top: 0;
  }
  @media (max-width: 520px) {
    margin-left: 0.5rem;
  }
  @media (max-width: 400px) {
    min-width: unset;
    margin-left: 0;
  }
`;

const imageStyle = {
  maxWidth: '100%',
  maxHeight: '100%',
  alignSelf: 'center',
};

const ImgContainer = styled.div`
  display: grid;
  justify-items: center;
  height: 11rem;
  padding: 2rem 1rem;
  @media (max-width: 768px) {
    padding: 1rem;
  }
`;
const ImgWrapperLogo = styled.div`
  display: grid;
  align-items: center;
  justify-content: center;
  border-bottom: solid 1px #e8e8e8;
  padding-bottom: 1rem;
  @media (max-width: 768px) {
    justify-items: center;
  }
`;
const StyledImgLogo = styled(LazyLoadImage)`
  height: 16px;
`;

const GridTop = styled.div`
  min-height: 3rem;
`;

const GridBottom = styled.div`
  min-height: 3rem;
  border-bottom: 4px solid #725cbd;
  padding: 1rem;
  width: 100%;
`;

const GridBottomText = styled(H2)`
  text-align: center;

  color: #000f16;
`;
const imageStyleTop = {
  width: '100%',
};

const ImgContainerTop = styled.div`
  display: grid;
  padding-top: 1rem;
  width: 100%;
  justify-content: end;
  grid-column: span 1;
  right: 0;
`;
const SecondHeadingSeçtion = styled.div`
  width: 100%;
  padding-bottom: 1rem;
  padding-top: 3rem;
`;

const SecondHeading = styled(H1)`
  width: 100%;
  font-family: 'Nunito Sans', sans-serif;
  font-weight: bold;
  text-align: center;
  grid-column: span 1;
  color: #151828;
  @media (min-width: 1440px) {
    font-size: 28px !important;
  }
`;
const SectionContent = styled(H2)`
  margin: auto;
  font-family: 'Nunito Sans', sans-serif;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.61;
  letter-spacing: normal;
  max-width: 64rem;
  width: 100%;
  padding: 0 5rem;
  color: #151828;
  padding-top: 0.5rem;
  text-align: center;
  img {
    margin-top: 1rem;
  }
  @media (max-width: 700px) {
    width: 100%;
    padding: 0rem 1rem;
  }
`;
const EsperManageSections = () => {
  return (
    <Section>
      <SecondHeadingSeçtion>
        <SecondHeading>
          Esper Enhanced Android Devices for <br />
          Digtial Signage Solutions.
        </SecondHeading>
        <SectionContent>
          Esper Enhanced Android Devices are devices that are shipped with a
          customized Android OS for enterprise devices delivering improved
          performance, faster deployement, and superior debugging. Esper tailors
          the OS to your specific needs, including in-ROM apps and specific
          peripheral support.
        </SectionContent>
      </SecondHeadingSeçtion>
      <SectionContainer>
        <Card onClick={() => navigate('/odroid-n2')}>
          <GridItem>
            <GridTop>
              <ImgContainerTop>
                <LazyLoadImage
                  effect="blur"
                  alt={'Esper Enhanced'}
                  src={EnhancedBadge}
                  style={imageStyleTop}
                />
              </ImgContainerTop>
            </GridTop>
            <ImgContainer>
              <LazyLoadImage effect="blur" src={odroid} style={imageStyle} />
            </ImgContainer>
            <ImgWrapperLogo>
              <StyledImgLogo src={odroidlogo} />
            </ImgWrapperLogo>
            <GridBottom>
              <GridBottomText>ODROID-N2</GridBottomText>
            </GridBottom>
          </GridItem>

          <CardContent>
            <CardDescription>
              Odroid N2 is a new generation SBC that is powerful, stable, and
              faster performing than the N1. It’s use cases range from a
              home/mini server to a full-featured media center.
            </CardDescription>
          </CardContent>
        </Card>
        <Card onClick={() => navigate('/khadas-edge-V')}>
          <GridItem>
            <GridTop>
              <ImgContainerTop>
                <LazyLoadImage
                  effect="blur"
                  alt={'Esper Enhanced'}
                  src={EnhancedBadge}
                  style={imageStyleTop}
                />
              </ImgContainerTop>
            </GridTop>
            <ImgContainer>
              <LazyLoadImage effect="blur" src={khadas} style={imageStyle} />
            </ImgContainer>
            <ImgWrapperLogo>
              <StyledImgLogo style={{ height: '30px' }} src={khadaslogo} />
            </ImgWrapperLogo>
            <GridBottom>
              <GridBottomText>Khadas Edge - V</GridBottomText>
            </GridBottom>
          </GridItem>

          <CardContent style={{ background: '#6abce5' }}>
            <CardDescription>
              Khadas Edge - V comes as a small footprint SBC with an edge
              connector, that can be used as standalone or with a base board.
              This SBC is thin and light with a dimensions of credit card.
              Khadas Edge - V runs Esper Enhanced Android.
            </CardDescription>
          </CardContent>
        </Card>
        <Card onClick={() => navigate('/odroid-c2')}>
          <GridItem>
            <GridTop>
              <ImgContainerTop>
                <LazyLoadImage
                  effect="blur"
                  alt={'Esper Enhanced'}
                  src={EnhancedBadge}
                  style={imageStyleTop}
                />
              </ImgContainerTop>
            </GridTop>
            <ImgContainer>
              <LazyLoadImage effect="blur" src={odroidc2} style={imageStyle} />
            </ImgContainer>
            <ImgWrapperLogo>
              <StyledImgLogo src={odroidlogo} />
            </ImgWrapperLogo>
            <GridBottom>
              <GridBottomText>ODROID-C2</GridBottomText>
            </GridBottom>
          </GridItem>

          <CardContent>
            <CardDescription>
              ODROID-C2 is a 64-bit quad-core SBC that can function as digital
              signages, interactive screens, gaming, home automation controller,
              and much more. Odroid C2 runs Esper Enhanced Android.
            </CardDescription>
          </CardContent>
        </Card>
      </SectionContainer>
    </Section>
  );
};

export default EsperManageSections;
